// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","385":"9d0a7bc1","513":"6133f073","551":"2cd26063","706":"711ede07","726":"baf948f3"}[chunkId] + ".chunk.js";
};